module.exports = __webpack_public_path__ + "assets/media/2.602b349e.wav";